<header class="top-bar" style="height: auto; margin-top: 10px;">
    <div style="display: flex;">
        <div style=" margin-left: auto; margin-right: auto; margin-bottom: 15px;">
            <img src="assets/icons/logo_saludTotal.svg"  width="300px" alt="img">            
        </div>
    </div>

    <div class="tool-bar">
        <a tabindex="15" class="return-menu focus-btn-volver" [attr.href]="urlRutaRegreso">
            <img class="icon-return-menu" src="assets/icons/Volver.svg" alt="img"> 
            <span class="d-none d-sm-block d-md-block">VOLVER ATRÁS</span>
            </a>
       </div>
</header>